import React from "react";
import classes from "../homepage/Lore.module.css";
import img from "../../assets/comet_2.png";

const Lore: React.FC = () => {
  return (
    <div className={classes["lore-wrapper"]}>
      <div className={classes["lore-content-wrapper"]}>
        <h2 className={classes["lore-title"]} data-aos="fade-right">
          Lore
        </h2>
        <div className={classes["lore-text"]} data-aos="fade-left">
          Space Kitties are the infamous space pirates of the galactic
          Kittyverse. Born into a time of strife, Space Kitties have adapted and
          thrived in the outer rims of civilization by learning how to loot,
          salvage and repair equipment left by ancient civilizations and
          unsuspecting merchants.
        </div>
        <br />
        <div className={classes["lore-text"]} data-aos="fade-right">
          Each Space Kitty is uniquely battle tested, and their Mech piloting
          skills are second-to-none. Living by their own rules every Space Kitty
          does their best to add even more loot to their treasure box every day,
          especially for the coveted $PACE token….
        </div>
        <br />
        <div className={classes["lore-text"]} data-aos="fade-left">
          Every Space Kitty’s dream is to enter and win in the notorious
          Galactic Battle Mech Tournament, a fighting arena where only the most
          skillful Kitty pilot their mechs against each other for glory, $PACE
          and prizes.
        </div>
        <br />
        <div className={classes["lore-text"]} data-aos="fade-right">
          The Mechs are the armored machines that Space Kitties use in battle.
          With only 1,250 mechs left in usable condition every mech is highly
          desired. Each mech has its own set of perks and attributes to serve
          the kitties in battle. Do not pass up on the opportunity to match your
          Space Kitty up with the strongest mech in the Kittyverse like it
          deserves. Together they make a great team and bring glory to your
          Kitten and prizes to the user.
        </div>
        <br /> <br />
        <br /> <br />
        <h2 className={classes["lore-title"]} data-aos="fade-right">
          What is $PACE?
        </h2>
        <div className={classes["lore-text"]} data-aos="fade-left">
          $PACE is the bread and butter of the Space Kitty treasure, their own
          currency. The kitties use it at every possible opportunity in order to
          continue to build their fortune. The latest news is that the kitties
          are using it to purchase and even upgrade their mechs.
        </div>
      </div>
      <img className={classes["comet"]} src={img} alt="" />
      <img className={classes["comet2"]} src={img} alt="" />
    </div>
  );
};

export default Lore;
